import PropTypes from 'prop-types';
import React from 'react';
import Popup from "reactjs-popup";
import AsyncSelect from 'react-select/async';
import { mergeSelectStyles } from '../../../../shared/darkSelectStyles';
const axios = require('axios').default;

const contentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "minWidth": "265px",
  "width": "auto",
  "zIndex": "1000",
  "background": "var(--sl-bg-primary)",
  "color": "var(--sl-text-primary)"
}

const selectStyles = mergeSelectStyles({
  container: (base) => ({ ...base, minWidth: "265px" }),
  menu: (base) => ({ ...base, width: "max-content", minWidth: "100%" }),
  option: (base) => ({ ...base, whiteSpace: "nowrap" }),
});

const promiseOptions = (inputValue, url) =>
  new Promise(resolve => {
    axios.get(url, {
        params: {
          name: inputValue
        }
      })
      .then(function (response) {
        const isGrouped = response.data.length > 0 && response.data[0].options;

        if (isGrouped) {
          resolve(response.data);
        } else {
          var newOptions = response.data.map(function(data){
            return { value: data.value, label: data.label };
          });
          resolve(newOptions);
        }
      })
  });

const LabeledSelectFilter = ({ filter, updateFilter }) => {
  const displayLabel = filter.displayValue && filter.displayValue.length > 0
    ? filter.displayValue[0]
    : (filter.value.length > 0 ? filter.value[0] : null);

  return (
    <div className="filter-pill-container mr-2 my-3">
      <Popup arrow={false}
             offsetY={5}
             position="bottom left"
             contentStyle={contentStyle}
             trigger={open => (
        <span className={"filter-pill clickable " + (open ? " opened " : "") + (filter.value.length > 0 ? " filtering " : "")}>
          <span className="px-1">{filter.label}</span>
          {filter.value.length === 1 &&
            <strong className="px-2">{displayLabel}</strong>
          }
          <i className="fa fa-chevron-down px-1"></i>
        </span>
      )} >
        {close => (
          <div>
            <AsyncSelect cacheOptions
                         placeholder={"Search"}
                         defaultOptions
                         autoFocus
                         menuIsOpen
                         styles={selectStyles}
                         onChange={(option) => {
                           updateFilter(filter, option.value, option.label);
                           close();
                         }}
                         loadOptions={(inputValue) => promiseOptions(inputValue, filter.optionsUrl)} />
          </div>
        )}
      </Popup>
    </div>
  );
};

LabeledSelectFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired
};

export default LabeledSelectFilter;
